import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyBAOtVnP2-7gUyezJW6oZKQ7jx3KEZEHHQ',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'blogsite-d7f52.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'blogsite-d7f52',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'blogsite-d7f52.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '840896004360',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:840896004360:web:f8d6be400cc71e5abdecbd',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-40RJNQYRBR',
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const analytics = typeof window !== 'undefined'
  ? (() => {
      try {
        return getAnalytics(app);
      } catch (error) {
        return null;
      }
    })()
  : null;
export default app;
